import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const UpsellSection = ({ 
  recommendations = [], 
  onAddToCart = () => {},
  addedItems = new Set()
}) => {
  if (recommendations?.length === 0) {
    return null;
  }

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-2 p-6">
      <div className="flex items-center space-x-2 mb-6">
        <Icon name="Sparkles" size={20} className="text-accent" />
        <h2 className="text-lg font-semibold text-foreground">Enhance Your Experience</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {recommendations?.map((item) => {
          const isAdded = addedItems?.has(item?.id);
          
          return (
            <div key={item?.id} className="border border-border rounded-lg p-4 hover:shadow-elevation-2 transition-shadow">
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0">
                  <Image
                    src={item?.image}
                    alt={item?.name}
                    className="w-16 h-16 rounded-md object-cover"
                  />
                </div>
                
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <h3 className="font-medium text-foreground">{item?.name}</h3>
                      <p className="text-sm text-muted-foreground mt-1">{item?.description}</p>
                      
                      {item?.originalPrice && item?.originalPrice > item?.price && (
                        <div className="flex items-center space-x-2 mt-2">
                          <span className="text-sm text-muted-foreground line-through">
                            ${item?.originalPrice?.toFixed(2)}
                          </span>
                          <span className="text-sm bg-accent text-accent-foreground px-2 py-1 rounded-full font-medium">
                            Save ${(item?.originalPrice - item?.price)?.toFixed(2)}
                          </span>
                        </div>
                      )}
                      
                      <div className="flex items-center justify-between mt-3">
                        <span className="text-lg font-semibold text-foreground">
                          ${item?.price?.toFixed(2)}
                        </span>
                        
                        <Button
                          variant={isAdded ? "success" : "outline"}
                          size="sm"
                          onClick={() => onAddToCart(item)}
                          disabled={isAdded}
                          iconName={isAdded ? "Check" : "Plus"}
                          iconPosition="left"
                        >
                          {isAdded ? 'Added' : 'Add'}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {item?.features && item?.features?.length > 0 && (
                <div className="mt-3 pt-3 border-t border-border">
                  <ul className="space-y-1">
                    {item?.features?.slice(0, 3)?.map((feature, index) => (
                      <li key={index} className="flex items-center space-x-2 text-xs text-muted-foreground">
                        <Icon name="Check" size={12} className="text-success flex-shrink-0" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          );
        })}
      </div>
      {/* Popular Badge */}
      <div className="mt-4 p-3 bg-accent/10 rounded-lg border border-accent/20">
        <div className="flex items-center space-x-2">
          <Icon name="TrendingUp" size={16} className="text-accent" />
          <span className="text-sm font-medium text-accent">
            85% of customers add these items to their order
          </span>
        </div>
      </div>
    </div>
  );
};

export default UpsellSection;